<div class="root row align-middle">
  <div class="profileImg" [ngStyle]="{'background-image': 'url('+ member.avatar + ')' }"></div>
  <div class="column">
    <div class="row">
      <div class="name columns">{{member.displayName}}</div>
      <div class="score columns small-2">{{member.score}}</div>
    </div>
  </div>
</div>